function renderSwatchesSlider(element) {

    $(element).slick({
        infinite: false,
        draggable: false,
        swipeToSlide: false,
        prevArrow:
            '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="7" height="13" viewBox="0 0 7 13" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 11.89L1.03998 6.25L7 0.61L6.65997 0.25L0.309997 6.25L6.65997 12.25L7 11.89Z" fill="#3A3C39"/></svg></button>',
        nextArrow:
            '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="7" height="13" viewBox="0 0 7 13" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 1.11L5.96002 6.75L0 12.39L0.340027 12.75L6.69 6.75L0.340027 0.75L0 1.11Z" fill="#3A3C39"/></svg></button>',
        responsive: [
            {
                breakpoint: 480,
                settings: 'unslick',
            },
        ],
    });

    function adjustSlidesToShow() {
        const slickListWidth = element.querySelector('.slick-list')?.clientWidth;
        const itemsPerSlide = Math.floor(slickListWidth / 25); // 25 is the total width of the swatch on desktop including margin

        if (window.innerWidth > 480) {
            $(element).slick(
                'slickSetOption',
                {
                    slidesToShow: itemsPerSlide,
                    slidesToScroll: itemsPerSlide,
                },
                true
            );
        }

        const arrowNext = element.parentElement.querySelector('.color-swatch-list__arrow--next');
        const arrowPrev = element.parentElement.querySelector('.color-swatch-list__arrow--prev');

        if (window.innerWidth <= 480 && element.scrollWidth > element.offsetWidth) {
            arrowNext.classList.add('color-swatch-list__arrow--show');

            element.addEventListener('scroll', function () {
                const scrollLeft = element.scrollLeft;
                const swatchesVisibleWidth = element.offsetWidth;
                const swatchesTotalWidth = element.scrollWidth;

                if (scrollLeft > 0) {
                    arrowPrev.classList.add('color-swatch-list__arrow--show');
                    arrowNext.classList.add('color-swatch-list__arrow--show');
                } else if (scrollLeft + swatchesVisibleWidth < swatchesTotalWidth) {
                    arrowPrev.classList.remove('color-swatch-list__arrow--show');
                }

                if (scrollLeft + swatchesVisibleWidth >= swatchesTotalWidth) {
                    arrowNext.classList.remove('color-swatch-list__arrow--show');
                }
            });
        } else {
            arrowNext.classList.remove('color-swatch-list__arrow--show');
            arrowPrev.classList.remove('color-swatch-list__arrow--show');
        }
    }

    window.addEventListener('resize', adjustSlidesToShow);
    setTimeout(() => adjustSlidesToShow(), 500);
}